<template>
    <div>
        <div class="container">
            <div class="titleBar">
                <span class="mgl20">{{$t('CreatePage.editFile')}}</span>                        
                <el-button class="rightButton" @click="goBack">{{$t('CreatePage.backButton')}}</el-button>
            </div>        

            <el-steps :active="active" align-center style="margin-top:50px">
                <el-step :title="$t('FileMenu.inputUpload')"></el-step>
                <el-step :title="$t('FileMenu.executeAdd')"></el-step>
                <el-step :title="$t('FileMenu.completeAdd')"></el-step>
            </el-steps>  

            <el-row v-if="active == 1" class="step-box" style="margin-top:20px">
                <div class="grid-content">
                    <div class="grid-con-icon"></div>
                    <div class="grid-cont-right">
                        <div style="margin-bottom:10px" class="font-set"><span class="redRequired">*</span>{{$t('FileMenu.fileType')}}</div>
                        <el-select v-model="fileType" :placeholder="$t('Message.select')">
                            <el-option key="1" :label="$t('FileMenu.configFile')" value="1"></el-option>
                            <el-option key="2" :label="$t('FileMenu.securityFile')" value="2"></el-option>
                        </el-select>                                      
                    </div>
                </div>   

                <div class="grid-content" style="margin-top:20px">
                    <div class="el-icon-upload grid-con-icon"></div>
                    <div class="grid-cont-right">
                        <div style="margin-bottom:10px" class="formTitle">{{$t('FileMenu.uploadTitle')}}</div>
                        <div style="margin-bottom:10px" class="font-set">{{$t('FileMenu.uploadTip')}}</div>
                        <el-upload
                            style="width:50%"
                            :action="archiveUrl()"
                            :on-remove="removeArchive"
                            :on-success="onArchive"   
                            :before-upload="beforeUploadFile"
                            
                            list-type="fileList"
                            ref="archiveUp"
                            :limit="1"
                            :on-exceed="handleExceed">
                            <el-button size="mini" type="primary">上传</el-button>
                        </el-upload>                               
                    </div>
                </div>                                             
            </el-row>       

            <el-row v-if="active == 2" class="step-box" style="margin-top:20px">
                <div class="grid-content" style="height:110px">
                    <div class="el-icon-success grid-con-icon"></div>
                    <div class="grid-cont-right">
                        <div style="margin-bottom:10px" class="formTitle">{{$t('FileMenu.importable')}}</div>
                        <div style="margin-bottom:10px;color:#409EFF" class="formTitle">{{importable}}</div>                               
                    </div>
                </div>   

                <div class="grid-content" style="margin-top:20px;height:110px">
                    <div class="el-icon-warning grid-con-icon"></div>
                    <div class="grid-cont-right">
                        <div style="margin-bottom:10px" class="formTitle">{{$t('FileMenu.notImport')}}</div>
                        <div style="margin-bottom:10px;color:#409EFF" class="formTitle">{{notImport}}</div>                               
                    </div>
                </div>                  
            </el-row>            

            <el-row v-if="active == 3" class="step-box" style="margin-top:20px">
                <div style="text-align: center;margin-top: 50px">
                    <div class="el-icon-success" style="font-size:100px;color:#4BD863"></div>
                    <div class="formTitle" style="font-size:30px;margin-top:20px">{{$t('FileMenu.addSuccess')}}</div>
                </div>   
              
            </el-row>  

            <div class="buttonCenter">
                <el-button style="width:100px" type="primary" v-if="active != 3" @click="next">{{$t('Button.next')}}</el-button>  
                <el-button v-if="active === 2" @click="goBackUpload">{{$t('Button.backUpload')}}</el-button>

                <el-button style="width:100px" type="primary" v-if="active === 3" @click="finish">{{$t('Button.finish')}}</el-button>  

            </div>                           
        </div>


    </div>
</template>

<script>
import bus from '../../common/bus';
import Tools from '../../common/Tools';
import api from '../../../api/api.js';
import apiAllSystem from '../../../api/apiAllSystem.js';
import apiArchive from '../../../api/apiArchive.js';

export default {
    name: 'taskCreate',
    components: { 

    },     
    data() {
        return {
            labelPosition: "top",
            pagesize: 10, //每页显示条数
            curPage: 1,   //当前页数         
            multipleSelection: [],
            tableData: [],
            loading: false,
            fileType: "",
            active: 1,
            importable : 5,
            notImport: 5,
            archiveId: 0
        };
    },
    
    created() {

    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },  
                
        goBackUpload() {
            this.active --;
        },    
        
        next() {
            if(this.active === 1) {
                if(this.fileType == "") {
                    this.$message.warning('请选择文件类型');
                    return;
                }
                if(this.archiveId == 0) {
                    this.$message.warning('请上传参数配置表');
                    return;
                }
                this.active ++;
            } else if(this.active === 2) {
                this.active ++;
            }            
        },

        finish() {
            this.$router.push({path:'/fileMenu'});
        },

        onSubmit(formName) {     
            this.$refs[formName].validate((valid) => {
                if (valid) {     
                    let params = { 
                        company: this.ruleForm.company,
                        group: this.ruleForm.group,
                        task_name: this.ruleForm.task_name,
                        task_type: this.ruleForm.task_type
                    };
                    
                    api.addDevice(params)
                    .then(res => {
                        if(res.state){
                            this.$message.error(this.$t('Message.success'));
                        } else {
                            this.$message.error(res.value.text);
                        }
                        
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('Message.reqError'));
                    });  
                }
            })                                                  
 
        },

        //上传文件路径
        archiveUrl(){
            return this.GLOBAL.serverSrc + "Archive?format=jpeg";     
        },      
        
        //文件限制格式、大小
        beforeUploadFile(file){
            let isFormat = file.name.endsWith('.ep');
            let islen = (file.size / 20 / 1024 / 1024) <= 1;
                            
            if (!isFormat) {
                this.$message.warning('上传文件只能是 ep 格式');
            }
            if (!islen) {
                this.$message.warning('上传文件大小不能超过 20MB');
            }
            return isFormat && islen;        
        },          

        //限制文件个数
        handleExceed(files, fileList) {
            this.$message.warning('最多只能上传 1 个文件');
        },     
        
        //文件上传成功
        onArchive(response, file, fileList) {
            var that = this;           
            if(response.state == true){
                that.$message({
                    message: '文件上传成功',
                    type: 'success'
                })
                that.archiveId = response.value;

                // var archive = {
                //     archive_id: ""
                // };
                // archive.archive_id = that.archiveId;
                // that.archiveJson.push(archive);   
           
            } else {
                that.$message({
                    message: response.message,
                    type: 'error'
                })                
            }            
        },

        //删除文件
        removeArchive(file, fileList) {
            if (file && file.status==="success") {
                var deleteId = file.response.value;//所要删除文件的id
                var that = this;           

                apiArchive.delectFile(deleteId)
                .then(res => {
                    if(res.state == true){
                        that.$message({
                            message: '文件删除成功',
                            type: 'success'
                        })   
                        that.archiveId = 0;
                        //文件json里删除id
                        // for (var i = 0;i < that.archiveJson.length; i++){
                        //     if (that.archiveJson[i].archive_id == deleteId){
                        //         that.archiveJson.splice(i,1);
                        //     }
                        // }
                    } else {
                        that.$message({
                            message: res.value.text,
                            type: 'error'
                        })                      
                    } 

                })
                .catch((error) => {
                    this.msg = error;
                })                   
            }

        },        
    }
};
</script>

<style scoped>
.step-box {  
    margin: auto;
    width: 70%;
}

.grid-content {
    display: flex;
    height: 160px;
    border: 1px solid #E9E9E9;
}

.grid-cont-right {
    flex: 1;
    padding-top: 30px;
    padding-left: 30px;
    text-align: left;
    border-left: 1px solid #E9E9E9;
}

.grid-cont-left {
    height: 100%;
    width: 120px;
    background-color: #F5F5F5;
}

.grid-con-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 80px;
    height: 100%;
    width: 120px;
    color: #CCCCCC;
    background-color: #F5F5F5;
}
.el-upload--text {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}


</style>
